<template>
  <v-row>
    <v-col cols="12">
      <hosting-password :hostingid="hostingid" title="Change Password for Reseller Hosting Plan:">
        <template #before-password>
          <v-col cols="12">
            <p class="mb-0">This will change the password for your main reseller hosting <b>{{ hosting.domain }}</b> only. </p>
          </v-col>
        </template>
      </hosting-password>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import HostingPassword from '@/components/Services/Hosting/HostingPassword'

export default {
  name: 'HostingWhmPassword',
  components: {
    HostingPassword,
  },
  props: {
    hostingid: {
      type: [String, Number],
      required: true,
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['hosting']),
  },
}
</script>
